import { QueryClientProvider } from '@tanstack/react-query';
import { Redirect, Route, Switch } from 'wouter';
import Layout from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { BreadcrumbProvider } from './lib/breadcrumbs';
import { queryClient } from './lib/query';
import { routes } from './lib/routeConfig';
import { useAuth } from './models/auth';
import { Auth } from './pages/Auth';
import ConnectMonday from './pages/ConnectMonday';

const QueryProvider = ({ children }: { children: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Auth />;
  }

  if (!user.mondayToken) {
    return <ConnectMonday />;
  }

  return (
    <QueryProvider>
      <BreadcrumbProvider>
        <Layout>
          <Switch>
            {routes.map(({ path, component, permissions, requireAll }) => (
              <Route
                key={path}
                path={path}
                component={(props) => (
                  <ProtectedRoute
                    component={component}
                    permissions={permissions}
                    requireAll={requireAll}
                    {...props}
                  />
                )}
                nest
              />
            ))}
            <Route>
              <Redirect to="/contacts" replace />
            </Route>
          </Switch>
        </Layout>
      </BreadcrumbProvider>
    </QueryProvider>
  );
}

export default App;
